import React from 'react'
import _ from 'lodash'

import ContributorListItem from './ContributorListItem'
import {
  fetchContributors,
  deleteContributor,
} from '../../../modules/portal-remote/portalService'
import { toast } from 'react-toastify'

export default class ContributorList extends React.Component {
  state = {
    contributors: [],
  }

  componentDidMount() {
    this.requestContributors()
  }

  requestContributors = async () => {
    try {
      const contributors = await fetchContributors()
      this.setState({ contributors })
    } catch (error) {
      toast.error(error.message)
    }
  }

  handleDelete = async contributor => {
    try {
      await deleteContributor(contributor._id)
      toast.success('Delete Contributor Success.')
      this.requestContributors()
    } catch (error) {
      toast.error(error.message)
    }
  }

  handleSelect = ({ _id }) => {
    this.props.history.replace(`/contributor/${_id}`)
  }

  render() {
    return (
      <div>
        {_.map(this.state.contributors, contributor => (
          <ContributorListItem
            key={contributor._id}
            contributor={contributor}
            onSelect={this.handleSelect}
            onDelete={this.handleDelete}
          />
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/templates/contributor-list/ContributorList.js